module.exports = __webpack_public_path__ + "static/img/10.7c77b66.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/10.png
// module id = o3Aq
// module chunks = 1